import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Shown when the visitor is not logged in, below an AI answer.
 */
export default function SaveAnswerPrompt() {
  return (
    <div className="mt-4 rounded-xl border border-amber-200 bg-amber-50/90 px-4 py-3 text-sm text-amber-950">
      <p className="font-medium text-amber-950 mb-2">
        Save this answer in your account and open <span className="font-semibold">My questions</span> anytime. If you
        already gave an email for designer notes, you will still get those emails — signing in just keeps your
        questions organized in one place.
      </p>
      <div className="flex flex-wrap gap-2">
        <Link
          to="/create-account"
          className="inline-flex items-center justify-center px-3 py-1.5 rounded-lg bg-green-600 text-white text-sm font-semibold hover:bg-green-700"
        >
          Create free account
        </Link>
        <Link
          to="/login"
          className="inline-flex items-center justify-center px-3 py-1.5 rounded-lg border border-amber-300 bg-white text-sm font-semibold text-amber-900 hover:bg-amber-100"
        >
          Log in
        </Link>
      </div>
      <p className="mt-2 text-xs text-amber-800/80">No spam. Just your answers and any notes from John.</p>
    </div>
  );
}
